import { render, staticRenderFns } from "./WaterMonitor.vue?vue&type=template&id=b1d1b5f0&scoped=true&"
import script from "./WaterMonitor.vue?vue&type=script&lang=ts&"
export * from "./WaterMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./WaterMonitor.vue?vue&type=style&index=0&id=b1d1b5f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d1b5f0",
  null
  
)

export default component.exports